import React, { useRef, useEffect, useState } from "react";
import axios from 'axios';
import './Modal.css';

const ip = process.env.REACT_APP_IP;

function ModalNouveauGroupe({ isOpen, setOpen, setSelectedGroupe, fetchGroups,token }) {
    const [nomGroupe, setNomGroupe] = useState("");
    const [descriptionGroupe, setDescriptionGroupe] = useState("");

    const wrapperRef = useRef(null);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setSelectedGroupe("0");
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (nomGroupe === "" || descriptionGroupe === "") {
            console.log("Tous les champs doivent être remplis");
        } else {
            try {
                const response = await axios.post(`${ip}/group`, {
                    nomGroupe,
                    descriptionGroupe
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                setNomGroupe("");
                setDescriptionGroupe("");
                fetchGroups();
                setSelectedGroupe(response.data.id);
                setOpen(false);
            } catch (error) {
                console.error('Erreur:', error);
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal_flex" ref={wrapperRef}>
                <div className="modal_title">Nouveau groupe</div>
                <input
                    type="text"
                    value={nomGroupe}
                    onChange={e => setNomGroupe(e.target.value)}
                    placeholder="Nom du Groupe"
                    className="titleModal modal_bloc pct-90 input-transparent"
                />
                <div></div>
                <textarea
                    value={descriptionGroupe}
                    onChange={e => setDescriptionGroupe(e.target.value)}
                    placeholder="Description du Groupe"
                    className="modal-corp pct-90 modal_bloc height_10vh input-transparent"
                />
                <button onClick={handleSubmit} className="pct-90 modal_bloc button-large">Enregistrer</button>
            </div>
        </div>
    );
}

export default ModalNouveauGroupe;
